
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminal",
      function () {
        return require("private-next-pages/terminal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminal"])
      });
    }
  